<template>
  <div class="input-wrapper" :class="{ focused: isFocused }">
    <label
      :for="inputData.name"
      v-if="data.Text && useLabel"
      :title="data.Text"
      >{{ data.Text }}</label
    >
    <input
      :ref="inputData.name"
      :id="inputData.name"
      :name="inputData.name"
      :required="inputData.required"
      type="text"
      :placeholder="data.Text && !useLabel ? data.Text : false"
      :autocomplete="
        data.Suggestions && data.Suggestions.length > 0 ? 'new-address' : false
      "
      class="input-text"
      v-model="inputVal"
      @keypress="onType"
      @focus="onFocus"
      @blur="onBlur"
      @input="onInput"
    />
    <div
      class="input-suggestions"
      v-if="data.Suggestions && data.Suggestions.length > 0"
    >
      <div
        class="input-suggestions-suggestion"
        v-for="(suggestion, index) in data.Suggestions"
        :key="'suggest_' + index"
        @mousedown="onSuggestionClick(suggestion.Value)"
      >
        {{ suggestion.Text }}
      </div>
    </div>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

export default {
  name: 'InputText',
  components: {},
  props: {
    value: String,
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String,
    useLabel: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      isFocused: false,
      inputData: {
        value: '',
        type: false,
        name: '',
        required: false
      }
    }
  },
  computed: {
    inputVal: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    alert: function(msg) {
      this.$store.commit('openToast', {
        text: msg,
        type: 'warning'
      })
    },
    validate: function(alert) {
      alert = !!alert

      this.$emit('input:value', this.inputVal)
      this.inputData.value = this.inputVal

      const parsedValue = PreApproveMe.parseInputValue(this.inputData)
      this.$emit('input:value-parsed', parsedValue)
      if (parsedValue !== false) {
        this.$emit('input:isvalid', true)
        // this.inputVal = parsedValue
        this.$emit('input', parsedValue)
      } else {
        this.$emit('input:isvalid', false)
        if (alert && this.inputVal) {
          this.alert(this.data.Text + ' is invalid')
        }
      }
    },
    formValidate: function() {
      if (
        this.$store.getters.getSection(this.sectionid) != null &&
        this.$store.getters.getPage(this.pageid) != null
      )
        this.validate(false) // Change to true to alert
    },
    onType: function() {},
    onFocus: function() {
      this.isFocused = true
      this.$emit('input:isfocused', true)
    },
    onBlur: function() {
      this.validate()
      this.isFocused = false
      this.$emit('input:isfocused', false)
    },
    onInput: function(event) {
      this.$emit('input:input', event)
    },
    onSuggestionClick: function(suggestion) {
      this.$emit('input:suggestion', suggestion)
    }
  },
  created: function() {
    this.inputData.type = this.data.Type
    this.inputData.name = this.data.Id
    this.inputData.required = this.data.Required

    if (this.data.Value)
      this.inputVal = this.data.Value
    
    // Validate if pre-filled
    this.$nextTick(function () {
      if (this.value)
        this.validate()
    })

    var vm = this
    this.$root.$on('form:validate', this.formValidate)
    this.$root.$on('form:validate-force', this.validate)
    this.$emit('input:created')
  },
  watch: {
    inputVal: function(value) {
      this.$emit('input:change', value)
      this.validate()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.input-wrapper {
  position: relative;
  input.input-text {
    &:-webkit-autofill {
    }
  }
  .input-suggestions {
    display: none;
  }
  &.focused {
    .input-suggestions {
      display: block;
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      z-index: 100;
      border-left: solid 1px $medium-gray;
      border-right: solid 1px $medium-gray;
      border-bottom: solid 1px $medium-gray;
      background: $white;
      .input-suggestions-suggestion {
        cursor: pointer;
        padding: 12px 12px;
        &:nth-child(even) {
          background: $light;
        }
        &:hover {
          background: $medium-gray;
        }
      }
    }
  }
}
</style>
